import { doc, setDoc } from "firebase/firestore";
import { db } from "../../firebase-config.js";

export const STREAK_REWARDS = Object.freeze({ guide: 7, breathing: 21, sounds: 60 });

export const STREAK_REWARD_KEYS = Object.freeze(Object.keys(STREAK_REWARDS));

export const BONUS_BREATHING_ID = 10;

export function getRecordStreak(currentStreak = 0, longestStreak = 0) {
  return Math.max(Number(currentStreak) || 0, Number(longestStreak) || 0);
}

export function readUnlockedRewards(user) {
  const stored = user?.streakRewards || {};
  return STREAK_REWARD_KEYS.reduce((acc, key) => ({ ...acc, [key]: Boolean(stored[key]) }), {});
}

export async function syncStreakRewards(uid, recordStreak, storedRewards) {
  if (!uid || !(recordStreak > 0)) return;

  const stored = storedRewards || {};
  const now = new Date().toISOString();
  const granted = {};

  STREAK_REWARD_KEYS.forEach((key) => {
    if (!stored[key] && recordStreak >= STREAK_REWARDS[key]) granted[key] = now;
  });

  if (!Object.keys(granted).length) return;

  try {
    await setDoc(doc(db, "users", uid), { streakRewards: granted }, { merge: true });
  } catch (error) {
    console.warn("Enregistrement des récompenses impossible.", error);
  }
}